<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('CAN_I_USE_BRASTER') }}</h3>
        </div>
        <steps :activeStep="3" :steps="4" class="text-xs-center mb-4"></steps>
        <div class="content__wrapper flex-center">
            <h4 class="stepper__content__title">
                {{ $t('SURGERY_AROUND_CHEST') }}
            </h4>
            <p class="stepper__content__title-description">{{ $t('SURGERY_AROUND_CHEST_DETAILS') }}</p>
            <div class="content__wrapper flex-center flex-row">
                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        name="s2q3Val"
                        value="YES"
                        @click="disallowByBreastSurgery()"
                        v-model="s2q3Val"
                    />
                    <span class="input-container">{{ $t('YES') }}</span>
                    <span class="checkmark"></span>
                </label>
                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        name="s2q3Val"
                        value="NO"
                        @click="goNext"
                        v-model="s2q3Val"
                    />
                    <span class="input-container">{{ $t('NO') }}</span>
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';
import { mapMedicalData } from './../../../main';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'survey-step2-q2',
    props: {
        single: Boolean,
    },
    data() {
        return {
            s2q3Val: null,
        };
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        goNext() {
            this.$store.commit('STATE_SURVEY', {
                section2: {
                    ...this.$store.getters.survey.section2,
                    active_section: 4,
                    disallow_by_breast_surgery: false,
                    q3: 'NO',
                },
            });
            this.$store.dispatch('setBrasterPermission', { brasterAllowed: true });
            if (!this.$store.state.survey.survey.showFirstLoginSurveyModal) {
                mapMedicalData();
                this.postComposition();
            }
        },
        disallowByBreastSurgery() {
            this.$store.commit('STATE_SURVEY', {
                section2: {
                    ...this.$store.getters.survey.section2,
                    active_section: 3,
                    disallow_by_breast_surgery: true,
                    q3: 'YES',
                },
            });
            this.$store.dispatch('setBrasterPermission', { brasterAllowed: false });
            mapMedicalData();
            if (this.$store.state.survey.survey.accountStage === 'MEDICAL_DATA_SET') {
                this.updateUserSurvey({ ...this.user.patient.survey, completionStage: 'DISALLOWED_AFTER_SURVEY' }).then(
                    () => this.postComposition(),
                );
            } else {
                this.updateUserSurvey({ ...this.user.patient.survey, completionStage: 'DISALLOWED' });
            }
        },
        postComposition() {
            this.$http.post('/openehr/api/composition/', this.$store.state.medicalData);
        },
    },
    components: {
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// survey-step2-q3.vue?61acbd28